import { Component } from 'react';
import Modal from '../common/modal';

/** @deprecated prefer `import { AlertModal } from '~/features/common/components/AlertModal';` */
class WRModalsAlert extends Component {
  TRANSLATED_OK = I18n.t('common.application.ok');

  render() {
    const { onClose, show, newUi, alertTextRenderer, text } = this.props;
    return (
      <Modal
        onSave={this.onSave}
        onClose={onClose}
        saveButtonTitle={this.TRANSLATED_OK}
        show={show}
        dontShowCancelButton
        dontShowHeader
        newUi={newUi}
      >
        <div className="wr-modals-alert--text">{alertTextRenderer ? alertTextRenderer(text) : text}</div>
      </Modal>
    );
  }

  onSave = (onFinish) => {
    if (typeof onFinish === 'function') onFinish();
    this.props.onClose();
  };
}

export default WRModalsAlert;
